import styled, { css } from 'styled-components';
import { Badge, ColorSwatchList, Button } from '@sainsburys-tech/bolt';
var ImageSkeleton = styled.span.withConfig({
  displayName: "ProductCardstyles__ImageSkeleton",
  componentId: "h52kot-0"
})(["display:flex;flex-direction:row;min-height:", ";height:", ";min-width:100px;width:", ";background-color:", ";max-width:100%;max-height:100%;"], function (props) {
  return "".concat(props.minHeight, "px");
}, function (props) {
  return "".concat(props.height, "px");
}, function (props) {
  return "".concat(props.width, "px");
}, function (props) {
  return props.color;
});
var Wrapper = styled.div.withConfig({
  displayName: "ProductCardstyles__Wrapper",
  componentId: "h52kot-1"
})(["display:flex;flex-direction:column;position:relative;padding:15px 0px;", " ", ""], function (props) {
  return css(["@media only screen and (max-width:", "){padding:15px;}"], props.theme.size.breakpoint['max-width'].xs);
}, function (props) {
  return props.loading && css(["display:block;margin-bottom:-1px;"]);
});
var ImageContainer = styled.div.withConfig({
  displayName: "ProductCardstyles__ImageContainer",
  componentId: "h52kot-2"
})(["cursor:pointer;position:relative;", " ", " ", ""], function (props) {
  var _props$mobileLayout;

  return ((_props$mobileLayout = props.mobileLayout) === null || _props$mobileLayout === void 0 ? void 0 : _props$mobileLayout.indexOf('horizontal')) === 0 && css(["@media only screen and (max-width:", "){width:100px;height:", ";min-width:100px;min-height:", ";}"], props.theme.size.breakpoint['max-width'].sm, props.isPortrait ? '136px' : '100px', props.isPortrait ? '136px' : '100px');
}, function (props) {
  return props.mobileLayout === 'horizontal-even' && css(["@media only screen and (max-width:", "){width:50%;height:100%;margin:0 10px;}"], props.theme.size.breakpoint['max-width'].sm);
}, function (props) {
  return props.loading && css(["display:block;margin-bottom:-1px;position:absolute;height:100%;width:100%;z-index:-1;"]);
});
var ImageWrapper = styled.div.withConfig({
  displayName: "ProductCardstyles__ImageWrapper",
  componentId: "h52kot-3"
})(["transition:opacity 0.5s;", " ", ""], function (props) {
  return css(["position:relative;padding:", "% 0 0;img{width:100%;height:", "%;display:block;max-width:100%;max-height:100%;position:absolute;top:0;bottom:0;left:0;right:0;}"], props.isPortrait ? 133 : 100, props.isPortrait ? 133 : 100);
}, function (props) {
  return props.imageLoading && css(["opacity:0;"]);
});
var flyoutBadgeStyles = css(["position:absolute;left:-5px;top:5px;", ""], function (props) {
  return css(["@media only screen and (max-width:", "){top:0px;}"], props.theme.size.breakpoint['max-width'].sm);
});
var SponsoredBadge = styled(Badge).withConfig({
  displayName: "ProductCardstyles__SponsoredBadge",
  componentId: "h52kot-4"
})(["", ""], flyoutBadgeStyles);
var MTOBadge = styled(Badge).withConfig({
  displayName: "ProductCardstyles__MTOBadge",
  componentId: "h52kot-5"
})(["", " line-height:12px;font-size:", ";"], flyoutBadgeStyles, function (props) {
  return props.theme.font.size.caption;
});
var ContentBlock = styled.div.withConfig({
  displayName: "ProductCardstyles__ContentBlock",
  componentId: "h52kot-6"
})(["margin-bottom:20px;", " ", " ", ""], function (props) {
  var _props$mobileLayout2;

  return ((_props$mobileLayout2 = props.mobileLayout) === null || _props$mobileLayout2 === void 0 ? void 0 : _props$mobileLayout2.indexOf('horizontal')) === 0 && css(["@media only screen and (max-width:", "){display:flex;flex-direction:row;margin-bottom:15px;}"], props.theme.size.breakpoint['max-width'].sm);
}, function (props) {
  return props.mobileLayout === 'horizontal-even' && css(["@media only screen and (max-width:", "){align-items:center;}"], props.theme.size.breakpoint['max-width'].sm);
}, function (props) {
  return props.availability && css(["height:100%;margin-bottom:15px;"]);
});
var TextContainer = styled.div.withConfig({
  displayName: "ProductCardstyles__TextContainer",
  componentId: "h52kot-7"
})(["display:flex;flex-direction:column;width:100%;", " ", ""], function (props) {
  var _props$mobileLayout3;

  return ((_props$mobileLayout3 = props.mobileLayout) === null || _props$mobileLayout3 === void 0 ? void 0 : _props$mobileLayout3.indexOf('horizontal')) === 0 && css(["@media only screen and (max-width:", "){margin-left:12px;}"], props.theme.size.breakpoint['max-width'].sm);
}, function (props) {
  return props.mobileLayout === 'horizontal-even' && css(["@media only screen and (max-width:", "){width:50%;margin:0 10px;}"], props.theme.size.breakpoint['max-width'].sm);
});
var BadgeContainer = styled.div.withConfig({
  displayName: "ProductCardstyles__BadgeContainer",
  componentId: "h52kot-8"
})(["display:flex;flex-direction:row;flex-wrap:wrap;padding:10px 0px 5px 0px;& > *{margin-right:5px;}", " ", ""], function (props) {
  var _props$mobileLayout4;

  return ((_props$mobileLayout4 = props.mobileLayout) === null || _props$mobileLayout4 === void 0 ? void 0 : _props$mobileLayout4.indexOf('horizontal')) === 0 && css(["@media only screen and (max-width:", "){position:unset;padding:0;}"], props.theme.size.breakpoint['max-width'].sm);
}, function (props) {
  return props.mobileLayout === 'vertical' && css(["@media only screen and (max-width:", "){gap:3px;}"], props.theme.size.breakpoint['max-width'].sm);
});
var ButtonContainer = styled.div.withConfig({
  displayName: "ProductCardstyles__ButtonContainer",
  componentId: "h52kot-9"
})(["display:flex;flex-direction:row;align-items:flex-end;margin-top:auto;.btn-cta{margin-right:5px;}", " ", ""], function (props) {
  var _props$mobileLayout5;

  return ((_props$mobileLayout5 = props.mobileLayout) === null || _props$mobileLayout5 === void 0 ? void 0 : _props$mobileLayout5.indexOf('horizontal')) === 0 && css(["@media only screen and (max-width:", "){width:100%;flex-basis:100%;justify-content:space-between;flex-direction:row-reverse;.btn-cta{margin-right:0px;}}"], props.theme.size.breakpoint['max-width'].sm);
}, function (props) {
  return props.mobileLayout === 'vertical' && css([".btn-cta{@media only screen and (max-width:", "){display:flex;justify-content:center;align-items:center;height:40px;width:100%;flex-basis:100%;margin-right:0;padding:10px;& > svg{display:none;}}}"], props.theme.size.breakpoint['max-width'].sm);
});
var BrandLogoContainer = styled.div.withConfig({
  displayName: "ProductCardstyles__BrandLogoContainer",
  componentId: "h52kot-10"
})(["display:flex;flex-direction:row;align-items:center;padding:5px 0;", " ", ""], function (props) {
  return css(["@media only screen and (min-width:", ") and (max-width:", "){padding:0;flex-direction:column;align-items:flex-start;margin-bottom:3px;}"], props.theme.size.breakpoint['min-width'].sm, props.theme.size.breakpoint['max-width'].sm);
}, function (props) {
  return !props.colorSwatchInline && css(["flex-direction:column;align-items:flex-start;"]);
});
var BrandedColorSwatchList = styled(ColorSwatchList).withConfig({
  displayName: "ProductCardstyles__BrandedColorSwatchList",
  componentId: "h52kot-11"
})(["width:100%;", " ", ""], function (props) {
  return props.hasBrand && props.colorSwatchInline && css(["margin-left:8px;padding-left:4px;border-left:1px solid ", ";@media only screen and (min-width:", ") and (max-width:", "){margin-left:0;padding-left:0;border-left:none;}"], props.theme.color.monochrome.base, props.theme.size.breakpoint['min-width'].sm, props.theme.size.breakpoint['max-width'].sm);
}, function (props) {
  return props.isFabricSwatches && !props.colorSwatchInline && css(["order:-1;margin-bottom:5px;"]);
});
var WishlistIconContainer = styled.div.withConfig({
  displayName: "ProductCardstyles__WishlistIconContainer",
  componentId: "h52kot-12"
})(["display:flex;align-items:center;justify-content:center;width:44px;height:44px;border-radius:3px;border:1px solid ", ";", ""], function (props) {
  return props.theme.color.monochrome.base;
}, function (props) {
  return props.mobileLayout === 'vertical' && css([".wishlist-checkbox__input{position:absolute;}.wishlist-checkbox__icon{@media only screen and (max-width:", "){align-self:center;height:17px;}}@media only screen and (max-width:", "){bottom:0;right:0;position:absolute;width:26px;height:26px;border-radius:50%;background-color:", ";border:1px solid ", ";label{opacity:0.6;}}"], props.theme.size.breakpoint['max-width'].sm, props.theme.size.breakpoint['max-width'].sm, props.theme.color.monochrome.white, props.theme.color.monochrome.light);
});
var Title = styled.div.withConfig({
  displayName: "ProductCardstyles__Title",
  componentId: "h52kot-13"
})(["font-size:", ";overflow:hidden;line-height:normal;margin-bottom:5px;"], function (props) {
  return props.theme.font.size.base;
});
var Link = styled.a.withConfig({
  displayName: "ProductCardstyles__Link",
  componentId: "h52kot-14"
})(["line-height:normal;"]);
var ValueMessagingContainer = styled.div.withConfig({
  displayName: "ProductCardstyles__ValueMessagingContainer",
  componentId: "h52kot-15"
})(["margin:5px 0px;"]);
var PriceContainer = styled.div.withConfig({
  displayName: "ProductCardstyles__PriceContainer",
  componentId: "h52kot-16"
})(["display:flex;flex-wrap:wrap;flex-direction:row;align-items:center;gap:5px;margin-top:5px;font-size:", ";& > *{margin-right:10px;}"], function (props) {
  return props.theme.font.size['display-1'];
});
var PriceText = styled.div.withConfig({
  displayName: "ProductCardstyles__PriceText",
  componentId: "h52kot-17"
})(["margin-top:5px;", ""], function (props) {
  return props.isValueMessaging && css(["margin:0;color:", ";"], props.hasWasPrice && props.theme.color.palette.red);
});
var PriceDivider = styled.span.withConfig({
  displayName: "ProductCardstyles__PriceDivider",
  componentId: "h52kot-18"
})(["font-size:", ";border-left:1px solid ", ";margin-left:5px;"], function (props) {
  return props.theme.font.size.base;
}, function (props) {
  return props.theme.color.monochrome.light;
});
var SavingTextContainer = styled.div.withConfig({
  displayName: "ProductCardstyles__SavingTextContainer",
  componentId: "h52kot-19"
})(["display:flex;flex-direction:row;margin:5px 0px;line-height:normal;", " ", ""], function (props) {
  return props.isValueMessaging && css(["margin:5px 0 0;"]);
}, function (props) {
  return css(["@media only screen and (max-width:", "){flex-direction:column;}"], props.theme.size.breakpoint['max-width'].sm);
});
var SavingText = styled.div.withConfig({
  displayName: "ProductCardstyles__SavingText",
  componentId: "h52kot-20"
})(["font-size:", ";color:", ";", ""], function (props) {
  return props.theme.font.size.base;
}, function (props) {
  return props.theme.color.palette.red;
}, function (props) {
  return props.isValueMessaging && css(["font-weight:", ";"], props.theme.font.weight['semi-bold']);
});
var WasText = styled.div.withConfig({
  displayName: "ProductCardstyles__WasText",
  componentId: "h52kot-21"
})(["text-decoration:line-through;", " ", ""], function (props) {
  return !props.isValueMessaging && css(["font-size:", ";color:", ";margin-left:4px;padding-left:4px;border-left:1px solid ", ";"], props.theme.font.size.base, props.theme.color.monochrome.base, props.theme.color.monochrome.base);
}, function (props) {
  return css(["@media only screen and (max-width:", "){margin-top:", ";margin-left:unset;padding-left:unset;border-left:unset;}"], props.theme.size.breakpoint['max-width'].sm, function () {
    return props.type === 'A' ? '3px' : '0';
  });
});
var DeliveryText = styled.div.withConfig({
  displayName: "ProductCardstyles__DeliveryText",
  componentId: "h52kot-22"
})(["line-height:normal;width:100%;font-size:", ";color:", ";"], function (props) {
  return props.theme.font.size.base;
}, function (props) {
  return props.theme.color.monochrome.base;
});
var AvailabilityLabelContainer = styled.div.withConfig({
  displayName: "ProductCardstyles__AvailabilityLabelContainer",
  componentId: "h52kot-23"
})(["display:flex;flex-direction:column;margin-bottom:15px;"]);
var AvailabilityLoadingContainer = styled.div.withConfig({
  displayName: "ProductCardstyles__AvailabilityLoadingContainer",
  componentId: "h52kot-24"
})(["div{padding:0;margin-bottom:5px;}"]);
var AvailabilityLabelWrapper = styled.div.withConfig({
  displayName: "ProductCardstyles__AvailabilityLabelWrapper",
  componentId: "h52kot-25"
})(["display:flex;"]);
var AvailabilityLabel = styled.span.withConfig({
  displayName: "ProductCardstyles__AvailabilityLabel",
  componentId: "h52kot-26"
})(["display:flex;align-items:center;margin-bottom:5px;", " svg{margin-right:8px;flex:0 0 20px;}"], function (props) {
  return props.hasBackgroundColor && css(["padding:5px;background-color:", ";"], function () {
    switch (props.icon) {
      case 'tick':
        return "".concat(props.theme.color.semantic.success.lighter);

      case 'info':
        return "".concat(props.theme.color.semantic.info.lighter);

      case 'out_of_stock':
        return "".concat(props.theme.color.semantic.error.lighter);

      default:
        return 'inherit';
    }
  });
});
var EMWBISWrapper = styled.span.withConfig({
  displayName: "ProductCardstyles__EMWBISWrapper",
  componentId: "h52kot-27"
})(["display:flex;align-items:center;svg{margin-right:8px;flex:0 0 20px;}"]);
var EMWBISButton = styled(Button).withConfig({
  displayName: "ProductCardstyles__EMWBISButton",
  componentId: "h52kot-28"
})(["text-align:left;padding:0;font-size:", ";"], function (props) {
  return props.theme.font.size.base;
});
var ProductLink = styled.a.withConfig({
  displayName: "ProductCardstyles__ProductLink",
  componentId: "h52kot-29"
})(["text-align:center;border-radius:3px;box-sizing:border-box;border:2px solid ", ";cursor:pointer;padding:10px 16px;overflow:hidden;font-weight:", ";font-size:", ";color:", ";"], function (props) {
  return props.theme.color.palette['brand-2'];
}, function (props) {
  return props.theme.font.weight.bold;
}, function (props) {
  return props.theme.font.size.base;
}, function (props) {
  return props.theme.color.palette['brand-2'];
}); // Alternative Images Slider for mobile

var AltImgViewport = styled.div.withConfig({
  displayName: "ProductCardstyles__AltImgViewport",
  componentId: "h52kot-30"
})(["display:flex;flex-direction:column;align-items:center;max-width:100%;width:100%;height:0;margin:0 auto;padding-bottom:", "%;position:relative;"], function (props) {
  return props.isPortrait ? 133 : 100;
});
var AltImgCarousel = styled.div.withConfig({
  displayName: "ProductCardstyles__AltImgCarousel",
  componentId: "h52kot-31"
})(["position:absolute;top:0;right:0;bottom:0;left:0;"]);
var AltImgScrollOuter = styled.div.withConfig({
  displayName: "ProductCardstyles__AltImgScrollOuter",
  componentId: "h52kot-32"
})(["display:flex;align-items:center;overflow-x:auto;overflow-y:hidden;width:100%;height:100%;-webkit-overflow-scrolling:touch;overflow:-moz-scrollbars-none;-ms-overflow-style:none;&::-webkit-scrollbar{display:none;}@supports (scroll-snap-align:start){scroll-snap-type:x mandatory;}@supports not (scroll-snap-align:start){-webkit-scroll-snap-type:mandatory;scroll-snap-type:mandatory;-webkit-scroll-snap-destination:0% center;scroll-snap-destination:0% center;-webkit-scroll-snap-points-x:repeat(100%);scroll-snap-points-x:repeat(100%);}"]);
var AltImgScroll = styled.div.withConfig({
  displayName: "ProductCardstyles__AltImgScroll",
  componentId: "h52kot-33"
})(["flex:1 0 100%;@supports (scroll-snap-align:start){scroll-snap-align:center;}@supports not (scroll-snap-align:start){scroll-snap-coordinate:0 0;}"]);
var AltImgIndicators = styled.div.withConfig({
  displayName: "ProductCardstyles__AltImgIndicators",
  componentId: "h52kot-34"
})(["display:flex;width:100%;justify-content:center;margin:0;padding:0;list-style:none;"]);
var AltImgIndicatorBtn = styled.span.withConfig({
  displayName: "ProductCardstyles__AltImgIndicatorBtn",
  componentId: "h52kot-35"
})(["appearance:none;background:none;border:none;overflow:hidden;display:flex;flex-direction:column;padding:8px;&:after{content:'';display:block;width:8px;height:8px;background:transparent;border:1px solid ", ";border-radius:50%;}&[aria-pressed='true']:after{background-color:", ";}"], function (props) {
  return props.theme.color.palette['brand-1'];
}, function (props) {
  return props.theme.color.palette['brand-1'];
});
var EnergyLabelWrapper = styled.div.withConfig({
  displayName: "ProductCardstyles__EnergyLabelWrapper",
  componentId: "h52kot-36"
})(["margin-top:", ";font-size:", ";"], function (props) {
  return props.theme.size.spacing.lg;
}, function (props) {
  return props.theme.font.size.caption;
});
export { ImageSkeleton, Wrapper, BadgeContainer, ButtonContainer, TextContainer, ContentBlock, ImageContainer, BrandLogoContainer, WishlistIconContainer, SavingTextContainer, ValueMessagingContainer, PriceContainer, Title, Link, PriceText, PriceDivider, SavingText, WasText, DeliveryText, ProductLink, BrandedColorSwatchList, ImageWrapper, SponsoredBadge, MTOBadge, AltImgViewport, AltImgCarousel, AltImgScroll, AltImgScrollOuter, AltImgIndicators, AltImgIndicatorBtn, AvailabilityLabel, AvailabilityLabelContainer, AvailabilityLabelWrapper, AvailabilityLoadingContainer, EnergyLabelWrapper, EMWBISWrapper, EMWBISButton };